<template>
  <div class="userManagement-container">
    <div class="use_box">
      <el-form :inline="true" :model="queryForm" @submit.native.prevent>
        <!--    <el-form-item  label="">
          <el-select v-model="queryForm.customerId" clearable placeholder=" ('public.Please_select')" @keyup.enter.native="fetchData">
            <el-option v-for="item in options" :key="item.id"  label="item.userName" :value="item.id" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="线路选择">
          <el-select v-model="queryForm.kor_type" filterable clearable placeholder="请选择" @change="queryData">
            <el-option label="韩到中/日" :value="0" />
            <el-option label="韩到马来" :value="4" />
          </el-select>
        </el-form-item>
        <el-form-item label="用户编号">
          <el-input v-model.trim="queryForm.user_code" clearable placeholder="请输入用户编号"
            @keyup.enter.native="fetchData" />
        </el-form-item>
        <el-form-item label="包裹单号">
          <el-input v-model.trim="queryForm.code" clearable placeholder="请输入包裹单号" @keyup.enter.native="fetchData" />
        </el-form-item>
        <el-form-item label="库位号">
          <el-input v-model.trim="queryForm.storage_location" clearable placeholder="请输入库位号"
            @keyup.enter.native="fetchData" />
        </el-form-item>
                <!-- 时间 -->
        <el-form-item label="时间">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            start-placeholder="开始时间"
            range-separator="-"
            value-format="yyyy-MM-dd HH:mm:ss"
            end-placeholder="结束时间"
            style="width: 360px"
            :default-time="['00:00:00', '23:59:59']"
            @change="getListData"
          />
        </el-form-item>
        <!--       <el-form-item label="库位号">
          <el-select
            v-model="queryForm.storage_location"
            filterable
            clearable
            placeholder="请选择"
            @change="handleChange"
          >
            <el-option
              v-for="item in options1"
              :key="item.store_number"
              :label="item.store_number"
              :value="item.store_number"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="queryData">
            查询
          </el-button>
          <el-button icon="" type="primary" @click="exportForm">
            导出
          </el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="listLoading" :data="list" border resizable style="width: 100%"
        :element-loading-text="elementLoadingText" @selection-change="setSelectRows">
        <el-table-column show-overflow-tooltip type="selection" />
        <el-table-column label="用户名称" align="center" prop="user_name" show-overflow-tooltip  />
        <el-table-column label="用户编号" align="center" prop="user_code" show-overflow-tooltip  />
        <el-table-column label="包裹单号" align="center" prop="old_kr_code" show-overflow-tooltip  />
        <!--        <el-table-column
          label="运单号"
          prop="express_code"
          show-overflow-tooltip
        /> -->
        <!--        <el-table-column label="商品体积(cm)" show-overflow-tooltip width="160">
          <template #default="{ row }">
            长 {{ row.length }} 宽{{ row.width }} 高 {{ row.height }}
          </template>
</el-table-column>
<el-table-column label=" ('palletsNumber')" prop="palletsNumber" width="80" show-overflow-tooltip />
<el-table-column label=" ('boxesNumber')" prop="boxesNumber" width="80" show-overflow-tooltip /> -->
        <el-table-column label="库位号"  align="center" prop="storage_location" show-overflow-tooltip />
        <el-table-column  align="center" label="库存天数">
          <template #default="{ row }">
            <div v-if="row.storedays > 30" style="color: red">
              {{ row.storedays }}天
            </div>
            <div v-else>{{ row.storedays }}天</div>
          </template>
        </el-table-column>
        <el-table-column label=" 入库时间"  align="center" prop="store_time" show-overflow-tooltip>
          <template #default="{ row }">
            <span>{{ row.store_time ? row.store_time : '-' }}</span>
            <el-button type="text" @click="getTime(row)">修改时间</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" >
          <template #default="{ row }">

              <el-button type="text" @click="chuku(row)">出库</el-button>
              <!-- <el-button type="text" @click="chuku_te(row)">特殊出库</el-button> -->
              <el-button type="text" @click="signOutbound(row)">签收出库</el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="queryForm.page" :layout="layout" :page-size="queryForm.limit"
        :total="total" style="margin-top: 10px" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
    </div>
    <out ref="out" @change="getNewList"></out>
    <el-dialog :title="chukuTitle" :visible.sync="te_show" width="600px" :close="te_Close">
      <div>
      </div>
      <el-form :inline="false" :model="teSubmitForm" @submit.native.prevent>
        <el-form-item label="用户编号">
          <el-input v-model="teSubmitForm.code" clearable placeholder="请输入包裹单号" disabled />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="teSubmitForm.remark" show-word-limit maxlength="100" type="textarea" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="te_Close">取 消</el-button>
        <el-button type="primary" @click="te_submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改入库时间 -->
    <el-dialog title="修改时间" :visible.sync="updateTime_show" width="600px" :close="time_Close">
      <div>
      </div>
      <el-form :inline="false" :model="old_time" label-width="100px" @submit.native.prevent>
        <el-form-item label="包裹单号">
          <el-input style="width: 200px;" v-model="old_time.code" clearable placeholder="请输入包裹单号" disabled />
        </el-form-item>
        <el-form-item label="原入库时间">
          <el-date-picker v-model="old_time.store_time" type="datetime" placeholder="选择日期时间" align="right"
            format="yyyy:MM:dd HH:mm:ss" value-format="yyyy:MM:dd HH:mm:ss" disabled>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="新入库时间">
          <el-date-picker v-model="new_time" type="datetime" placeholder="选择日期时间" align="right"
            format="yyyy:MM:dd HH:mm:ss" value-format="yyyy:MM:dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="time_Close">取 消</el-button>
        <el-button type="primary" @click="timeSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // wmsinventoryList,
  orderKuwei,
  orderGetAllStorageLocation,
  orderCheckout,
  Order_kuwei_out,
  outbound_new,
  OrderQuick_store_time_old,
  store_time_update,
  sign_for_outbound
  // user_selectUser
  // wmspositionListAll
} from '@/api/xgcApi'
// import {
//   getToken
// } from '@/utils/auth'
// import axios from 'axios'
// import store from '@/store'
import {
  getUploadUrl
} from '@/config'
import out from '../components/out'
export default {
  components: {
    out,
  },
  data() {
    return {
      updateTime_show: false,
      te_show: false,
      te_row: {},
      teSubmitForm: {
        "code": "", //描述
        "remark": "" //单号
      },
      exportLoading: false,
      list: null,
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      elementLoadingText: '正在加载...',
      queryForm: {
        page: 1,
        limit: 10,
        itemName: '',
        itemNo: '',
        customerId: '',
        storage_location: '',
        kor_type: 0,
        start_time:'',
        end_time:''
      },
      options1: [],
      options: [],
      timeOutID: null,
      choose_list_string: '',
      old_time: {
        code: '',
        store_time: ''
      },
      new_time: '',
      chukuTitle: '',
      time:''
    }
  },
  created() {
    this.fetchData()
    // this.getUserList()
    this.getLocalInfo()
  },
  beforeDestroy() {
    clearTimeout(this.timeOutID)
  },
  methods: {
    time_Close() {
      this.updateTime_show = false
      this.old_time = {
        code: '',
        store_time: ''
      }
      this.new_time = ''
    },
    timeSave() {
      var data = {
        "code": this.old_time.code,
        "store_time": this.new_time //入库时间
      }
      store_time_update(data).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.fetchData()
        this.time_Close()
      })
      console.log(data)
    },
        // 选择时间，提取开始时间，结束时间
    getListData() {
      if (this.time == null) {
        this.queryForm.start_time = '';
        this.queryForm.end_time = '';
      } else {
        this.queryForm.start_time = this.time[0];
        this.queryForm.end_time = this.time[1];
      }
    },
    getTime(row) {
      var data = {
        code: row.code
      }
      this.old_time = {
        code: row.code,
        id: row.id,
        store_time: row.store_time,
      }
      this.updateTime_show = true
      // OrderQuick_store_time_old(data).then(res=>{
      //   console.log(res , '返回信息')
      //   this.old_time = res.data
      //   this.updateTime_show = true
      // })
    },
    te_Close() {
      this.te_show = false
      this.teSubmitForm = {
        "code": "", //描述
        "remark": "" //单号
      }
    },
    // 批量导出
    exportForm() {
      if (this.selectRows.length > 0) {
        this.$baseConfirm('确定导出已选', null, async () => {
          var data = {
            id: this.choose_list_string
          }
          Order_kuwei_out(data).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '选择导出成功',
            })
            const fileUrl = getUploadUrl + res.data
            window.open(fileUrl)
          })


        })
      } else {
         Order_kuwei_out(this.queryForm).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '条件导出成功',
            })
            const fileUrl = getUploadUrl + res.data
            window.open(fileUrl)
          })
      }
    },
    chuku_te(row) {
      this.chukuTitle = '特殊出库'
      this.te_show = true
      this.te_row = row
      this.teSubmitForm.code = row.old_kr_code
    },


    signOutbound(row) {
      this.chukuTitle = '签收出库'
      this.te_show = true
      this.te_row = row
      this.teSubmitForm.code = row.old_kr_code
    },

    // 特殊出库提交
    te_submit() {

      if (this.chukuTitle == "特殊出库") {
        outbound_new(this.teSubmitForm).then(res => {
          this.$message({
            type: 'success',
            message: '特殊出库成功'
          })
          this.te_Close()
          this.fetchData()
        })
      } else {
        sign_for_outbound(this.teSubmitForm).then(res => {
          this.$message({
            type: 'success',
            message: '签收出库成功'
          })
          this.te_Close()
          this.fetchData()
        })
      }
    },
    // 出库操作
    chuku(row) {
      this.$refs['out'].showEdit(row)
      return
      orderCheckout({
        code: e.code
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '出库成功',
          })
        }
      })
    },
    // 称重机扫描打印
    getNewList(data) {
      this.fetchData()
    },
    // 选择位置
    handleChange(value) {
      this.queryForm.storage_location = value
      // const selectedLabel = this.options1.find(
      //   (option) => option.id === value
      // ).positionNo
      // this.queryForm.positionNo = selectedLabel
    },
    // getUserList() {
    //   orderGetAllStorageLocation().then((res) => {
    //     console.log(res)
    //     return
    //     this.options = res.userList
    //   })
    // },
    setSelectRows(val) {
      this.selectRows = val
      var arr = []
      val.forEach((item, index) => {
        arr.push(item.id)
      })
      this.choose_list_string = arr.join(',')
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    // 获取位置编号列表
    getLocalInfo() {
      var data = {}
      orderGetAllStorageLocation(data).then((res) => {
        this.options1 = res.data
      })
    },
    // 获取库存列表
    async fetchData() {
      this.listLoading = true
      const {
        data
      } = await orderKuwei(this.queryForm)

      // return
      this.list = data.data
      this.total = data.count
      this.timeOutID = setTimeout(() => {
        this.listLoading = false
      }, 300)
    },
  },
}
</script>
<style>
.use_box {
  background-color: #fff;
  /* padding: 5px; */
  box-sizing: border-box;
}
</style>
